import { render } from "./Container_1.vue?vue&type=template&id=6aec3dc5&ts=true"
import script from "./Container_1.vue?vue&type=script&lang=ts"
export * from "./Container_1.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__